import {Box, FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {useCallback} from 'react';
import {env} from '../../config/env';

export interface DropdownDifficultyProps {
  difficulty?: number;
  /** change of difficulty, undefined means any difficulty */
  onChange: (difficulty?: number) => void;

  /** Whether to disable the "Any Difficulty" option */
  disableAnyDifficulty?: boolean;
}

export default function DropdownDifficulty({
  difficulty,
  onChange,
  disableAnyDifficulty = false,
}: DropdownDifficultyProps) {
  const handleChangeWrapped = useCallback(
    (difficultyLabel: string) => {
      const difficultyOption = env.difficulty.find((difficultyOption) => difficultyOption.label === difficultyLabel);
      onChange(difficultyOption ? difficultyOption.value : undefined);
    },
    [onChange],
  );

  // Determine the Select value: use difficulty if provided, otherwise use "Any Difficulty" if enabled, or empty if disabled
  const selectedOption =
    difficulty !== undefined
      ? env.difficulty.find((difficultyOption) => difficultyOption.value === difficulty)
      : !disableAnyDifficulty
        ? env.difficulty[env.difficultyAnyIndex]
        : undefined;

  return (
    <FormControl fullWidth data-testid="dropdown-difficulty">
      <InputLabel>Difficulty</InputLabel>
      <Select
        value={selectedOption?.label ?? ''}
        onChange={(e) => handleChangeWrapped(e.target.value)}
        label="Difficulty"
      >
        {env.difficulty
          .filter((_difficultyOption, index) => !disableAnyDifficulty || index !== env.difficultyAnyIndex)
          .map((difficultyOption) => (
            <MenuItem key={difficultyOption.label} value={difficultyOption.label}>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    bgcolor: difficultyOption.color,
                  }}
                />
                {difficultyOption.label}
              </Box>
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
